import { useEffect, useMemo, type ReactNode } from "react";
import { createPortal } from "react-dom";

type Props = { children: ReactNode; id?: string; z?: number };

export default function BodyPortal({ children, id = "body-portal-root", z = 2147483647 }: Props) {
  const container = useMemo(() => {
    const el = document.createElement("div");
    el.setAttribute("id", id);
    el.style.position = "relative";
    el.style.zIndex = String(z);
    return el;
  }, [id, z]);

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      try { document.body.removeChild(container); } catch {}
    };
  }, [container]);

  return createPortal(children, container);
}
